import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';


export const getStockWarehouses = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/`, data);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehouses - error", error)
        return handleApiError(error)
    }
}

export const getStockWarehouseById = async (warehouseId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/stock-warehouse/${warehouseId}`);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehouseById - error", error)
        return handleApiError(error)
    }
}

export const searchStockWarehouse = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/search`, data);
        return await response.data;
    } catch (error) {
        console.log("searchStockWarehouseData - error", error)
        return handleApiError(error)
    }
}

export const insertStockWarehouse = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/insert`, data);
        return await response.data;
    } catch (error) {
        console.log("insertStockWarehouse - error", error)
        return handleApiError(error)
    }
}

export const getStockWarehousesForProcessRejectedStock = async (warehouseId) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/stock-adjustment/reject-stock/${warehouseId}`);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehousesForProcessRejectedStock - error", error)
        return handleApiError(error)
    }
}

export const getCreditNotesWithRejectedStock = async (docNo) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/stock-adjustment/credit-note/${docNo}`);
        return await response.data;
    } catch (error) {
        console.log("getCreditNotesWithRejectedStock - error", error)
        return handleApiError(error)
    }
}

export const getStockWarehouseByMaterialIds = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/materialIds`, data);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehouseByMaterialIds - error", error)
        return handleApiError(error)
    }
}

export const getStockWarehouseByWarehouseIdAndMaterialIdCombination = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/materialid-warehouseid`, data);
        return await response.data;
    } catch (error) {
        console.log("getStockWarehouseByWarehouseIdAndMaterialIdCombination - error", error)
        return handleApiError(error)
    }
}

export const getStockMovementReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse//report/stock-eod-warehouse`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const getStockAgingReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/report/aging`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const getRejectedStockReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/report/rejected-stock`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const getStockConsumptionStockReport = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/report/stock-consumption`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}

export const getStockAgingReportRaw = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/stock-warehouse/report-stock-aging`, data);
        return await response.data;
    } catch (error) {
        return handleApiError(error)
    }
}